import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7775c583"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "self-checkin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "SELF CHECKIN", -1))
const _hoisted_3 = { id: "ticket" }
const _hoisted_4 = { class: "ticket-name" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "count" }
const _hoisted_7 = { class: "ticket-code row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "코드 ", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "ticket-ordered-dt row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "구매일", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 0,
  class: "ticket-canceled-dt row"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "취소일 ", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "ticket-expiry-date row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "만료일", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 1,
  class: "ticket-used-dt row"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "사용일", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert" }, [
  /*#__PURE__*/_createTextVNode("시티투어 기사님 외에는 사용버튼을 '절대' 누르지마세요. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 사용처리 시 취소/환불 불가합니다.")
], -1))
const _hoisted_23 = {
  key: 2,
  class: "button used"
}
const _hoisted_24 = {
  key: 3,
  class: "button expiry"
}
const _hoisted_25 = {
  key: 4,
  class: "button expiry"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(item.count) + "장", 1)
        ]))
      }), 256)),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.ticket.code), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.ticket_ordered_dt), 1)
      ]),
      (_ctx.is_canceled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.ticket_canceled_dt), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.ticket_expiry_date), 1)
      ]),
      (_ctx.is_used)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.ticket_used_dt), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_22,
      (_ctx.is_used)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "사용함"))
        : (_ctx.is_canceled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, "취소됨"))
          : (_ctx.is_expiry)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, "만료됨"))
            : (!_ctx.is_used&&!_ctx.is_expiry)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  class: "button no-used",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.use && _ctx.use(...args)))
                }, "사용"))
              : _createCommentVNode("", true)
    ])
  ]))
}